export default __webpack_public_path__ + "static/media/francheville13.428ed690.jpg";